<template>
  <nav class="navbar" :style="{'left': positionLeft}" ref="navbar">
    <ul>
      <li class="navbar-item" v-for="(nav, index) in this.pageSet" :key="index">
        <router-link :to="{ name: 'top', hash: nav.path }" v-smooth-scroll>
          <span>{{ nav.alt }}</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data () {
    return {
      positionLeft: 0,
      navContentWidth: 110
    }
  },
  props: {
    pageSet: {
      required: true
    }
  },
  created () {
    window.addEventListener('resize', this.handleNavPosition)
  },
  mounted () {
    this.handleNavPosition()
  },
  methods: {
    handleNavPosition () {
      const contentWidth = 900
      const windowWidth = window.innerWidth
      const margin = 80
      if (windowWidth - contentWidth > 0) {
        this.positionLeft = (windowWidth - contentWidth) / 2 - this.navContentWidth - margin + 'px'
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import url('https://use.typekit.net/ezx8vjy.css');

.navbar {
  position: absolute;
  top: 240px;
  z-index: 50;
  &-item {
    text-align: left;
    color: white;
    letter-spacing: 0.05em;
    font: normal normal bold 18px hypatia-sans-pro;
    &:not(:first-of-type) {
      margin-top: 14px;
    }
  }
}
</style>
